<template>
  <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="page-title-box noprint">
        <h4 class="page-title">Salesman Order</h4>
        <span class="text-primary">Order sales from customer by salesman</span>
        <div class="mt-2">
          <button type="button" class="btn btn-sm btn-hard-primary" @click="addSales"><i class="fa fa-plus"></i></button>
          <button type="button" class="btn btn-sm btn-hard-primary" @click="refreshList"><i class="fa fa-refresh"></i></button>
          <button type="button" class="btn btn-sm btn-soft-primary" data-toggle="modal" data-target="#modalSaleOrderFilter" data-backdrop="static" data-keyboard="false">Filter</button>
        </div>
      </div>
      <div class="row" v-if="dataRaw.length > 0">
        <div class="col-md-12" v-for="(i, index) in filterData" :key="index">
          <div class="card" @click="editSales(i.id)">
            <div class="card-body">
              <div class="row">
                <div class="col-4 col-sm-4 col-md-4">
                  <img :src="`${publicPath}asset/img/product.png`" alt="">
                </div>
                <div class="col-8 col-sm-8 col-md-8">
                  <dl class="row">
                    <dt class="col-md-4">Order No.</dt>
                    <dd class="col-md-8">
                      {{ i.order_no }}
                      <span class="badge badge-success" v-if="i.status === 'open'">{{ i.status }}</span>
                      <span class="badge badge-primary" v-else-if="i.status === 'approved'">{{ i.status }}</span>
                      <span class="badge badge-warning" v-else>{{ i.status }}</span>
                    </dd>
                    <dt class="col-md-4">Date</dt>
                    <dd class="col-md-8">{{ i.order_date | dateFormat('DD/MM/YYYY') }}</dd>
                    <dt class="col-md-4">Customer</dt>
                    <dd class="col-md-8">{{ i.customer }}</dd>
                    <dt class="col-md-4">SP No.</dt>
                    <dd class="col-md-8">{{ i.project_name }}</dd>
                    <dt class="col-md-4">Total</dt>
                    <dd class="col-md-8">{{ i.total | currency }}</dd>
                    <dt class="col-md-4">Salesman</dt>
                    <dd class="col-md-8">{{ i.salesman }} <b>[{{ i.salesman_id }}]</b></dd>
                  </dl>
                  <div class="progress">
                    <div class="progress-bar" id="progress-bar-success" role="progressbar" :style="{ width: i.progress + '%' }">{{ i.progress }} %</div>
                  </div>
                  <!-- <pre>{{ i }}</pre> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4 col-sm-4 col-md-4">
                  <img :src="`${publicPath}asset/img/product.png`" alt="">
                </div>
                <div class="col-8 col-sm-8 col-md-8">
                  <p class="data-load">&nbsp;</p>
                  <p class="data-load">&nbsp;</p>
                  <p class="data-load">&nbsp;</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4 col-sm-4 col-md-4">
                  <img :src="`${publicPath}asset/img/product.png`" alt="">
                </div>
                <div class="col-8 col-sm-8 col-md-8">
                  <p class="data-load">&nbsp;</p>
                  <p class="data-load">&nbsp;</p>
                  <p class="data-load">&nbsp;</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4 col-sm-4 col-md-4">
                  <img :src="`${publicPath}asset/img/product.png`" alt="">
                </div>
                <div class="col-8 col-sm-8 col-md-8">
                  <p class="data-load">&nbsp;</p>
                  <p class="data-load">&nbsp;</p>
                  <p class="data-load">&nbsp;</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SaleSalesmanOrderModal @filter="getFilter"/>
      <button type="button" class="btn btn-hard-primary btn-floating btn-lg" id="btn-back-to-top" @click="scrollTop"><i class="fa fa-arrow-up"></i></button>
      <pre>{{ dataRaw }}</pre>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { saleOrderUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import SaleSalesmanOrderModal from '@/components/sales/SaleSalesmanOrderModal.vue'

export default {
  name: 'SaleSalesmanOrderList',
  props: ['scroll', 'idx'],
  components: {
    Loading,
    SaleSalesmanOrderModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      publicPath: process.env.BASE_URL,
      dateNow: new Date(),
      view: 'table',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#6ED861',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      begin: date1,
      end: date2,
      dataRaw: [],
      filterCategory: [],
      filterType: [],
      filterAccount: false,
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1,
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshList()
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      rowsTable: state => state.data.rowsTable,
      categoryList: state => state.products.productCategoryList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (var name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterAccount === true) {
          if (d.account_code_persediaan !== d.type_code_persediaan) {
            return d
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        var start = (this.currentPage - 1) * this.pageSize
        var end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async getFilter (value) {
      this.begin = new Date(value.begin)
      this.end = new Date(value.end)
      await this.refreshList()
    },
    scrollTop () {
      window.scrollTo(0, 0)
    },
    viewChange: function (v) {
      this.view = v
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const start = this.begin ? this.begin.getFullYear() + '-' + (this.begin.getMonth() + 1) + '-' + this.begin.getDate() : null
      const finish = this.end ? this.end.getFullYear() + '-' + (this.end.getMonth() + 1) + '-' + this.end.getDate() : null
      var obj = {
        user: this.authUser.username,
        begin: start,
        end: finish
      }
      console.log(obj)
      console.log(saleOrderUrl + '/salesman')
      axios.post(saleOrderUrl + '/salesman', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          this.loader.isLoading = false
          this.$Progress.finish()
          console.log(error.response)
        })
    },
    addSales () {
      this.$emit('newSales')
    },
    editSales (id) {
      axios.get(saleOrderUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.$emit('editSales', response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style>
#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: block;
  color: white;
}
#progress-bar-success {
  background-color: #6FB56F;
}
.data-load {
  width: 100%;
  background-color: aliceblue;
}
</style>
